import { primary } from './primary';
import { dark } from './dark';
import { orange } from './orange';
import { yellow } from './yellow';
import { lime } from './lime';
import { green } from './green';
import { blue } from './blue';
import { teal } from './teal';
import { purple } from './purple';
import { magenta } from './magenta';
import { pink } from './pink';
import { red } from './red';

export const BrainfishColors = {
  primary,
  dark,
  orange,
  yellow,
  lime,
  green,
  blue,
  teal,
  purple,
  magenta,
  pink,
  red,
};
